import { ScreenNames } from "@swiggy-private/portal-dineout-context";

export const OBJECT_POSITION = "1";

export const SCREEN_NAME = ScreenNames.MENU;
